import { isNil } from "lodash-es";

export function isEmptyObject(obj: unknown) {
  return (
    !isNil(obj) && Object.keys(obj).length === 0 && obj.constructor === Object
  );
}
